import React from 'react';
import PropTypes from 'prop-types';

import './agreement.scss';

const Agreement = ({action}) => (
  <p className="agreement">
    By pressing {action}, I agree to Fireswan’s <br />
    <a href="https://www.fireswan.app/terms-of-use">Terms of Use</a>,{' '}
    <a href="https://www.fireswan.app/privacy-policy">Privacy Policy</a> and{' '}
    <a href="https://www.fireswan.app/cookie-policy">Cookie Policy</a>
  </p>
);

Agreement.propTypes = {
  action: PropTypes.string.isRequired,
};

export default Agreement;
